// 보호 계정(소유자) 식별자.
// 어떤 관리자도 이 계정 대상으로 대신 행위(예약/취소)·관리자 권한 변경을 할 수 없다.
// 백엔드(api/lib/protectedAccount.ts)가 권위, 프론트는 UI 차단(1차).
export const PROTECTED_STUDENT_ID = '20241476';

export const isProtectedStudent = (studentId) =>
  String(studentId || '') === PROTECTED_STUDENT_ID;
